import { useEffect, useState } from 'react';
import { CalBookingProps, UrlAction } from '../types';
import { resolveUrlParams } from './utils';

interface UseResolveUrlPropsProps extends CalBookingProps {
    setRescheduleUid: (uid: string) => void;
    setCancelBookingId: (uid: string) => void;
    setEventSlug: (slug: string) => void;
    setTeamId: (teamId: number) => void;
    setUserName: (userName: string) => void;
    isBookingDryRun: boolean;
    setSelectedHostId: (selectedHostId: number) => void;
}

export const useResolveUrlProps = (props: UseResolveUrlPropsProps) => {
    const [
        {
            slug: urlSlug,
            action: urlAction,
            teamId: urlTeamId,
            username: urlUsername,
            bookingUid,
            isUrlAction,
            selectedHostId,
        },
    ] = useState(() => resolveUrlParams(props.isBookingDryRun));

    useEffect(() => {
        if (bookingUid) {
            if (isUrlAction) {
                props.setEventSlug(urlSlug || props.eventSlug);
                props.setTeamId(urlTeamId || props.teamId);
                props.setUserName(urlUsername || props.userName);
                selectedHostId && props.setSelectedHostId(selectedHostId);
            }
            if (urlAction === UrlAction.RESCHEDULE) {
                props.setRescheduleUid(bookingUid);
            }
            if (urlAction === UrlAction.CANCEL) {
                props.setCancelBookingId(bookingUid);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
